import { FormsMultilineInput } from '@platform/components';
import cx from 'classix';
import { FieldValues } from 'react-hook-form';

/** Wraps FormsMultiline in a specified height to account for help text */
export const ApplicationMultilineInput = <Fdata extends FieldValues>(
  props: React.ComponentProps<typeof FormsMultilineInput<Fdata>> & { extendedHeight?: boolean, extendedHeightValue?: string },
) => {
  const { extendedHeight, extendedHeightValue, ...rest } = props;
  return (
    <div className={cx(extendedHeight && (extendedHeightValue ? extendedHeightValue : 'h-[210px]'))}>
      <FormsMultilineInput {...rest} stretchHeight={extendedHeight} />
    </div>
  );
};
